// extracted by mini-css-extract-plugin
export default {"root":"style_root__hBfqL","wrapper":"style_wrapper__41RBm"};